import { Component, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { Title, Meta } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { IdiomaService } from 'src/app/core/services/idioma.service';
import { OnExecuteData, OnExecuteErrorData, ReCaptchaV3Service } from 'ng-recaptcha';
import { Subscription } from 'rxjs';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { ApiService } from 'src/app/core/services/api.service';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SimpleModalComponent } from 'src/app/shared/modals/simple-modal/simple-modal.component';

@Component({
  selector: 'app-teste-assinatura-eletronica',
  templateUrl: './teste-assinatura-eletronica.component.html',
  styleUrls: ['./teste-assinatura-eletronica.component.scss']
})

export class TesteAssinaturaEletronicaComponent implements OnInit, OnDestroy {
  data: any;

  idiomaSelecionado;
  idiomas;

  formGroup: FormGroup;

  public recentToken = '';
  public recentError?: { error: any };
  public readonly executionLog: Array<OnExecuteData | OnExecuteErrorData> = [];

  private allExecutionsSubscription: Subscription;
  private allExecutionErrorsSubscription: Subscription;
  private singleExecutionSubscription: Subscription;

  constructor(
    private translate: TranslateService,
    private idiomaService: IdiomaService,
    private titleService: Title,
    private meta: Meta,
    private router: Router,
    private formBuilder: FormBuilder,
    private apiService: ApiService,
    private modalService: NgbModal,
    private recaptchaV3Service: ReCaptchaV3Service,
    private gaService: GoogleAnalyticsService,
    private renderer: Renderer2
  ) {
    this.carregarFormGroup();

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.carregarDados();
      this.idiomaSelecionado = this.idiomaService.getIdioma();
    });
  }

  ngOnInit() {
    this.carregarDados();

    this.idiomaSelecionado = this.idiomaService.getIdioma();
    this.idiomas = this.idiomaService.getIdiomas();

    this.allExecutionsSubscription = this.recaptchaV3Service.onExecute
    .subscribe((data) => this.executionLog.push(data));
  
    this.allExecutionErrorsSubscription = this.recaptchaV3Service.onExecuteError
    .subscribe((data) => this.executionLog.push(data));

    this.renderer.addClass(document.body, 'recaptcha');
  }

  ngOnDestroy() {
    if (this.allExecutionsSubscription) {
      this.allExecutionsSubscription.unsubscribe();
    }
    if (this.allExecutionErrorsSubscription) {
      this.allExecutionErrorsSubscription.unsubscribe();
    }
    if (this.singleExecutionSubscription) {
      this.singleExecutionSubscription.unsubscribe();
    }

    this.renderer.removeClass(document.body, 'recaptcha');
  }

  carregarDados() {
    this.translate.get('TESTE_ASSINATURA_ELETRONICA').subscribe(res => {
      this.data = res;
      this.titleService.setTitle(this.data.HEADER_TITLE);
      this.meta.updateTag({name: 'description', content: this.data.META_DESCRIPTION});
      this.meta.updateTag({name: 'keywords', content:  this.data.META_KEYWORDS});
      this.gaService.pageView(this.router.url);
    });
  }

  carregarFormGroup() {
    this.formGroup = this.formBuilder.group(
      {
        formNome: new FormControl('', Validators.required),
        formEmail: new FormControl('', Validators.compose(
          [
            Validators.required,
            Validators.email
          ]
        ))
       }
    );
  }

  alterarIdioma(idioma) {
    this.translate.use(idioma);
  }
  
  onSubmit() {
    if (this.singleExecutionSubscription) {
      this.singleExecutionSubscription.unsubscribe();
    }
    this.singleExecutionSubscription = this.recaptchaV3Service.execute('teste_assinatura_eletronica')
      .subscribe(
        (token) => {
          this.recentToken = token;
          this.recentError = undefined;

          this.apiService.demoAssinatura(
            this.recentToken,
            this.formGroup.get('formNome').value,
            this.formGroup.get('formEmail').value
          )
            .subscribe(
              res => {
                const modalRef = this.modalService.open(SimpleModalComponent, { windowClass: 'xlModal', centered: true });
                modalRef.componentInstance.message = this.data.MENSAGEM_SUCESSO;
              },
              err => {
                let message;
                if (err != null && err.error != null) {
                  message = err.error;
                } else {
                  message =  this.data.MENSAGEM_ERRO;
                }
                const modalRef = this.modalService.open(SimpleModalComponent, { windowClass: 'xlModal', centered: true });
                modalRef.componentInstance.message = message;
                this.formGroup.reset();
              }
            );
        },
        (error) => {
          this.recentToken = '';
          this.recentError = { error };

          const modalRef = this.modalService.open(SimpleModalComponent, { windowClass: 'xlModal', centered: true });
          modalRef.componentInstance.message = this.recentError;
          this.formGroup.reset();
        },
      );
  }

}
